import axios from "axios";
import { makeServer } from "../mirage/server";

let client;

if (true) {
 client = axios.create({
    baseURL: "https://sara-journal-backend-weathered-haze-8997.fly.dev",
  });

} else { 
  console.log("API URL: ", process.env.REACT_APP_API_URL);
  client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
}

export default client;

export const setHeaderAndInterceptors = (token, setUserData) => {
  client.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  client.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err?.response?.status === 401) {
        localStorage.removeItem("userData");
        setUserData(null);
      } else throw err;
    }
  );
};
